var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-select',{ref:"treeSelect",attrs:{"props":_vm.props,"options":_vm.data,"value":_vm.value1,"parent-select":_vm.pSelect,"clearable":false,"placeholder":"请选择","disabled":_vm.disabledStatus==2},on:{"node-select":function($event){return _vm.select($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }